var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBnbChain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "#F0B90B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6323 14.6892L24.0002 10.4004L31.368 14.6892L28.6591 16.2735L24.0002 13.5692L19.3409 16.2735L16.6323 14.6892ZM31.368 20.098L28.6591 18.5135L24.0002 21.218L19.3409 18.5135L16.6323 20.098V23.2668L21.2913 25.971V31.3799L24.0002 32.9643L26.709 31.3799V25.971L31.368 23.2668V20.098ZM31.368 28.6754V25.5066L28.6591 27.091V30.2598L31.368 28.6754ZM33.2912 29.7955L28.6322 32.4998V35.6686L36 31.3799V22.8024L33.2912 24.3866V29.7955ZM30.5823 17.3935L33.2912 18.9779V22.1467L36 20.5623V17.3935L33.2912 15.8092L30.5823 17.3935ZM21.2913 33.6472V36.816L24.0002 38.4004L26.709 36.816V33.6472L24.0002 35.2316L21.2913 33.6472ZM16.6323 28.6754L19.3409 30.2598V27.091L16.6323 25.5066V28.6754ZM21.2913 17.3935L24.0002 18.9779L26.709 17.3935L24.0002 15.8092L21.2913 17.3935ZM14.7088 18.9779L17.4177 17.3935L14.7088 15.8092L12 17.3935V20.5623L14.7088 22.1467V18.9779ZM14.7088 24.3866L12 22.8024V31.3799L19.3681 35.6686V32.4998L14.7088 29.7955V24.3866Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnbChain);
export default __webpack_public_path__ + "static/media/bnb-chain.098184ac9bb39406b4f42b2f5deef0eb.svg";
export { ForwardRef as ReactComponent };